import React, { Component, Fragment } from 'react';
import SearchModalCIE10Table from './SearchModalCIE10Table';
import SearchModalCIe10TableActions from './SearchModalCIe10TableActions';
import Modal from '@material-ui/core/Modal';
import { Col, Row, Button } from 'reactstrap';
import TextField from '@material-ui/core/TextField';

class SearchModalCIE10 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cie10Data: [],
            loading: false,
            filterText: null
        };
    }

    componentDidMount = () => {
    }

    searchDataCIE10 = async () => {
        this.setState({ loading: true });
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'cie10/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ filtro: this.state.filterText })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Error consultando los CIE 10");
            }
        }).then((dataCie10) => {
            if (dataCie10.existe == true) {
                this.setState({ cie10Data: dataCie10.contenido, loading: false }, () => {
                    console.log("cie10Data: ", this.state.cie10Data);
                });
            }
            else {
                this.setState({ cie10Data: [], loading: false }, () => {
                });
            }
        }).catch(err => {
            console.log(err);
            this.setState({ loading: false });
        });
    }

    render() {
        return (<Fragment>
            <Modal
                open={this.props.openModalCIE10}
                onClose={() => {
                    this.props.closeModalCIE10();
                    this.setState({filterText: null, cie10Data: []});
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '90%', height: '75%', margin: 10, overflowY: "auto" }}>
                    <div>
                        <h5 className="bold-text">Diagnostico</h5>
                    </div>

                    <label>
                        Escriba el Código CIE10 o su Nombre y presione Enter o haz Click en el Boton buscar
                    </label>
                    <br /><br />

                    <div>
                        <Row>
                            <Col md={10}>
                                <TextField
                                    required
                                    className="medical-material-form__field"
                                    style={{ width: '100%' }}
                                    id="cie10-filter"
                                    label="Código CIE10 o Nombre"
                                    type="text"
                                    value={this.state.filterText}
                                    onChange={(e) => {
                                        this.setState({ filterText: e.target.value });
                                    }}
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            this.searchDataCIE10();
                                        }
                                    }}
                                />
                            </Col>
                            <Col md={2}>
                                <Button
                                    className="btn btn-sm"
                                    color="primary"
                                    onClick={() => {
                                        this.searchDataCIE10();
                                    }}
                                    style={{ margin: 10 }}
                                >
                                    Buscar
                                </Button>
                            </Col>
                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                        {!this.state.loading ?
                            <SearchModalCIE10Table
                                title=""
                                reactTableData={this.state.cie10Data}
                                config={{
                                    withPagination: true,
                                    withSearchEngine: false,
                                    isSortable: false,
                                    watchCustomMenu: false,
                                }}
                                ReactTableActions={SearchModalCIe10TableActions}
                                Callback={(diagnostic) => {
                                    this.props.Callback(diagnostic);
                                }}
                            /> : <div style={{ margin: 'auto', width: 270, height: 420 }}>
                                <div className="load__icon-wrap">
                                    <svg className="load__icon">
                                        <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                                    </svg>
                                </div>
                            </div>}
                        {
                            !this.state.loading && this.state.cie10Data.length === 0 ?
                                <div style={{ margin: 'auto', width: 270, height: 420 }}>
                                    No hay elementos CIE10 que mostrar
                                </div>
                                : null
                        }
                    </div>
                </div>
            </Modal>
        </Fragment>);
    }
}

export default SearchModalCIE10;
